/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {doLevelMatch} from '../targeting/semantic-targeting.util';

@Component({
  standalone: false,
  selector: 'adn-targeting-semantic-summary',
  template: '<div *ngFor="let t of target"><strong *ngIf="t.negated">NOT </strong>{{t.sentence.sentence}}, {{t.managedScore?.key}}<span *ngIf="t.positiveSentimentOnly">, avoiding negative articles</span></div>'
})
export class SemanticSummaryComponent implements OnChanges {
  @Input() targets: any;

  target: any[] = [];

  ngOnChanges(): void {
    this.target = _.cloneDeep(this.targets) || [];
    _.forEach(this.target, (s) => {
      if (s.score) {
        s.managedScore = doLevelMatch(s.score);
      }
    });
  }
}
